import React, { Component } from "react";
import "./wishlist.css";
import WishProductListing from "../collection/common/wish-product-listing";
import WishFilterBar from "../collection/common/wish-filter-bar";
import {
  getCommonCounter,
  getMasterDetailsId,
  getNotificationCounter,
  getUpdateQuantity,
  getWishlist,
  isInquiryOrCart,
  setHeaderCounters,
} from "../../actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  getOpenStoreIdApp,
  getValueFromLanguageObject,
  loadUserDetailsFromLocalStorage,
} from "../../store";
import EditWishListModal from "./EditWishListModal";
import {
  clearLocalStorageReload,
  getWishListId,
  getWishListName,
  isOpenStoreIdExist,
  navigateTo,
  openLinkInNewTab,
  removeUserDetailAndOtherDetails,
} from "../../utils/utils";
import { deleteCall, getCall, postCall } from "../../api/post";
import { getWishListProductUrl } from "../../services";
import ErrorMessageAnimationModal from "../../animation/ErrorMessageAnimationModal";
import NoSpecialProductFoundAnim from "../../animation/NoSpecialProductFoundAnim";
import ProductLoaderMain from "../layouts/contentloader/product-loader";
import { confirmAlert } from "react-confirm-alert";
import DeleteAnim from "../../animation/AnimFiles/DeleteAnim";
import ConfirmAlertPopup from "../../Alert/ConfirmAlertPopup";
import SuccessMessageAnimationModal from "../../animation/SuccessMessageAnimationModal";
import MainLoader from "../../animation/MainLoader";
import AddToCartAnim from "../../animation/AddToCartAnim";
import ShareWishListModal from "./ShareWishListModal";
import Breadcrumb from "../common/breadcrumb";

class Wishlist extends Component {
  state = {
    wishListProduct: [],
    sortingOrder: 0,
    showErrorMessageModal: false,
    errorMessage: "",
    showSuccessMessageModal: false,
    successMessage: "",
    skip: 0,
    limit: 20,
    isContentLoaderVisible: false,
    isShareWishListOpen: false,
  };

  componentDidMount() {
    const userDetails = loadUserDetailsFromLocalStorage();
    const { id: userId } = userDetails || {};
    if (userId) {
      this.fetchWishlist(userId);
    }
    // Dispatch master details fetch
    this.props.initMasterDetailsId();
  }

  fetchWishlist = async (userId) => {
    try {
      this.setState({ isContentLoaderVisible: true });

      const wishlistUrl = "v2/wishlists";
      const response = await getCall(wishlistUrl, { userId });

      this.setState({ isContentLoaderVisible: false });

      if (response.error) {
        const { message, statusCode } = response.error || {};
        this.loadErrorMessageAnimation(message);
        if (statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else {
        console.log("Wishlist fetch successful:", response);
        const { data } = response || {};
        console.log("Fetched wishlist data:", data);
        this.setState({ wishListProduct: response });
      }
    } catch (error) {
      this.setState({ isContentLoaderVisible: false });
      console.error("Error fetching wishlist:", error);
    }
  };
  onSearchProduct = (value) => {
    this.setState(
      {
        searchValue: value,
        skip: 0,
        productList: [],
      },
      () => {
        this.initWishListProducts();
      }
    );
  };

  handleSortingProductFilter = (order) => {
    this.setState(
      {
        sortingOrder: order,
        skip: 0,
        isContentLoaderVisible: true,
        wishListProduct: [],
      },
      () => {
        this.initWishListProducts().then(() => {
          this.setState({ isLoading: false });
        });
      }
    );
  };

  LayoutViewClicked = () => {};

  openFilter = () => {
    document.querySelector(".collection-filter").style = "left: -15px";
  };

  handlePagination = () => {
    const { wishListProduct, skip, limit } = this.state || {};
    const newSkip = skip + limit;
    this.setState({ skip: newSkip }, () => {
      this.fetchWishlist(loadUserDetailsFromLocalStorage().id);
    });
  };

  addToCart = async (product, qty) => {
    if (qty === "") {
      return;
    }
    const { isInquiry, counter, updateQuantity } = this.props;
    try {
      this.setState({ isLoading: true });
      let userDetails = loadUserDetailsFromLocalStorage();
      if (!isOpenStoreIdExist() && userDetails === undefined) {
        return;
      } else {
        userDetails = userDetails === undefined ? {} : userDetails;
      }
      const { id, cityId } = userDetails;
      const openStoreId = getOpenStoreIdApp();
      let userId = openStoreId ? openStoreId : id;

      const addtocartUrl = isInquiry
        ? "orders/productInquiry"
        : "orders/addtocart";
      var addtocartObj = {
        orderstatus: 1,
        inshoppingcart: 1,
        orderdetails: [
          {
            quantity: qty,
            productId: product.id,
          },
        ],
        userId,
        cityId: cityId,
        date: new Date(),
      };
      if (!isInquiry) {
        const totalAmountObj = { totalamount: product.price * parseFloat(qty) };
        addtocartObj = { ...addtocartObj, ...totalAmountObj };
      }
      const addToCartResponse = await postCall(addtocartUrl, addtocartObj);
      this.setState({ isLoading: false });
      if (addToCartResponse.error) {
        clearLocalStorageReload({ response: addToCartResponse });
        this.loadErrorMessageAnimation(addToCartResponse.error.message);
        if (addToCartResponse.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else if (
        addToCartResponse.message &&
        (
          addToCartResponse.message === "Sorry! Product is out of stock" ||
          addToCartResponse.message === "Sorry! Product is not availble as per given quantity"
        )
      ) {
        // Show error modal for these messages
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_product_out_of_stock") ||
          addToCartResponse.message ||
          "Sorry! Product is out of stock"
        );
        return;
      } else {
        if (isInquiry) {
          const strAddToInquirySuccessfully =
            getValueFromLanguageObject("str_add_to_inquiry_successfully") ||
            "Product inquiry added successfully";
          this.loadAddToCartMessageAnimation(strAddToInquirySuccessfully);
        } else {
          const strAddToCartSuccessfully =
            getValueFromLanguageObject("str_add_to_cart_successfully") ||
            "Product added to cart successfully";
          this.loadAddToCartMessageAnimation(strAddToCartSuccessfully);
        }

        // Add a small delay to ensure backend has finished updating the counter
        setTimeout(async () => {
          await counter();
          updateQuantity();
          await this.fetchHeaderCounters();
        }, 500);
      }
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handleClickOfQuickView = () => {};

  removeProductFromWishlist = async (wishlistId) => {
    console.log("Removing wishlist item with ID:", wishlistId);
    const removeProductFromWishlistUrl = `v2/wishlists/${wishlistId}`;
    this.setState({ isLoading: true });
    const removeProduct = await deleteCall(removeProductFromWishlistUrl);
    this.setState({ isLoading: false });
    if (removeProduct.error) {
      clearLocalStorageReload({ response: removeProduct });
      this.loadErrorMessageAnimation(removeProduct.error.message);
      if (
        removeProduct &&
        removeProduct.error &&
        removeProduct.error.statusCode &&
        removeProduct.error.statusCode === 401
      ) {
        this.removeUserDetailAndRedirectToLogin();
        return;
      }
    } else {
      const strProductHasBeenRemovedSuccessfully =
        getValueFromLanguageObject(
          "str_product_has_been_removed_successfully"
        ) || "Product has been removed successfully!";
      this.loadSuccessMessageAnimation(strProductHasBeenRemovedSuccessfully);
      this.setState({ isLoading: true, skip: 0, productList: [] }, async () => {
        await this.fetchWishlist(loadUserDetailsFromLocalStorage().id);
        await this.fetchHeaderCounters(); // <-- Add this line
      });
    }
  };

  onClickOfDeleteWishlist = (wishlistId) => {
    console.log("Clicked delete for wishlist ID:", wishlistId);
    const strRemoveProduct =
      getValueFromLanguageObject("str_title_remove_product") ||
      "Remove Product";

    const strNo = getValueFromLanguageObject("str_no") || "No";

    const strYesRemoveIt =
      getValueFromLanguageObject("str_yes_remove_it") || "Yes, Remove it!";

    confirmAlert({
      customUI: ({ onClose }) => {
        const submitClick = () => {
          this.setState({ isLoading: true }, () => {
            this.removeProductFromWishlist(wishlistId).then(() => {
              this.setState({ isLoading: false });
            });
            onClose();
          });
        };
        return (
          <>
            <ConfirmAlertPopup
              title={strRemoveProduct}
              message={
                getValueFromLanguageObject("str_remove_product_cart")
                  ? getValueFromLanguageObject("str_remove_product_cart")
                  : "Are you sure you want to remove this product?"
              }
              animation={<DeleteAnim />}
              submit={strYesRemoveIt}
              submitClick={submitClick}
              cancelClick={onClose}
              cancel={strNo}
            />
          </>
        );
      },
    });
  };

  showEditWishListModal = () => {
    this.setState({ isEditWishListNameOpen: true });
  };

  hideEditWishListModal = () => {
    this.setState({ isEditWishListNameOpen: false });
  };

  showShareWishListModal = () => {
    this.setState({ isShareWishListOpen: true });
  };

  hideShareWishListModal = () => {
    this.setState({ isShareWishListOpen: false });
  };

  onCloseEditWishListNameModal = () => {
    this.hideEditWishListModal();
  };

  onCloseShareWishListModal = () => {
    this.hideShareWishListModal();
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadSuccessMessageAnimation = (message) => {
    this.setState({ successMessage: message, showSuccessMessageModal: true });
  };

  loadAddToCartMessageAnimation = (message) => {
    this.setState({
      addToCartMessage: message,
      showAddToCartMessageModal: true,
    });
  };

  fetchHeaderCounters = async () => {
    try {
      const response = await getCall("v2/dashboard/header-counters", []);
      if (response.error) {
        return;
      }
      this.setState({ headerCounters: response });
      this.props.setHeaderCounters(response); // <-- dispatch to Redux
    } catch (e) {}
  };

  render() {
    const {
      isEditWishListNameOpen,
      isShareWishListOpen,
      wishListProduct,
      showErrorMessageModal,
      errorMessage,
      isPaginationEnableForProductList,
      limit,
      isContentLoaderVisible,
      showSuccessMessageModal,
      successMessage,
      isLoading,
      showAddToCartMessageModal,
      addToCartMessage,
    } = this.state || {};
    const { wishlist } = this.props || {};

    // ✅ Add safety check for wishListProduct
    const safeWishListProduct = Array.isArray(wishListProduct)
      ? wishListProduct
      : [];
    console.log("Safe Wish List Product:", safeWishListProduct);

    return (
      <>
        <div className="collection-content">
          <Breadcrumb
            title={getValueFromLanguageObject("str_wishlist") || "Wishlist"}
          />
          <div className="collection-content container pb-5 pt-3">
            <div className="page-main-content">
              <div className="collection-product-wrapper">
                {/* <div className="wishlist-header">
                      </div> */}

                {/* ✅ Use safe array for length checks */}
                {safeWishListProduct.length > 0 && (
                  <WishProductListing
                    productList={safeWishListProduct}
                    colSize={3}
                    handlePagination={this.handlePagination}
                    limit={limit}
                    isPaginationEnableForProductList={
                      isPaginationEnableForProductList
                    }
                    addToCart={this.addToCart}
                    handleClickOfQuickView={this.handleClickOfQuickView}
                    onClickOfDeleteWishlist={this.onClickOfDeleteWishlist}
                    isVisibleDeleteWishlist={true}
                    masterDetailsObj={this.props.masterDetailsObj}
                  />
                )}

                {isContentLoaderVisible && <ProductLoaderMain />}

                {/* ✅ Use safe array for length checks */}
                {safeWishListProduct.length === 0 &&
                  !isContentLoaderVisible && <NoSpecialProductFoundAnim />}
              </div>
            </div>
          </div>
        </div>
        {isLoading && <MainLoader />}
        {isEditWishListNameOpen && (
          <EditWishListModal
            wishlist={wishlist}
            isEditWishListNameOpen={isEditWishListNameOpen}
            onCloseEditWishListNameModal={() => {
              this.onCloseEditWishListNameModal();
            }}
            onSuccessEditWishListNameModal={() => {
              this.onCloseEditWishListNameModal();
              const userDetails = loadUserDetailsFromLocalStorage();
              const { id } = userDetails || {};
              if (id) {
                this.props.getWishlist(id);
              }
            }}
          />
        )}
        {isShareWishListOpen && (
          <ShareWishListModal
            wishlist={wishlist}
            isShareWishListOpen={isShareWishListOpen}
            onCloseShareWishListModal={() => {
              this.onCloseShareWishListModal();
            }}
          />
        )}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}

        {showSuccessMessageModal && (
          <SuccessMessageAnimationModal
            show={showSuccessMessageModal}
            message={successMessage}
            onClose={() => {
              this.setState({ showSuccessMessageModal: false });
            }}
          />
        )}
        {showAddToCartMessageModal && (
          <AddToCartAnim
            show={showAddToCartMessageModal}
            message={addToCartMessage}
            onClose={() => {
              this.setState({ showAddToCartMessageModal: false });
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  wishlist: state.settings.wishlist,
  isInquiry: state.settings.isInquiry,
  masterDetailsObj: state.masterDetails.masterDetailsObj, // ✅ Add this line
});

export default connect(mapStateToProps, {
  counter: getCommonCounter,
  notificationCounter: getNotificationCounter,
  isInquiryOrCart: isInquiryOrCart,
  updateQuantity: getUpdateQuantity,
  getWishlist: getWishlist,
  initMasterDetailsId: getMasterDetailsId,
  setHeaderCounters, // <-- add this
})(withRouter(Wishlist));
